import { OTHERS_DATA_KEY } from '@keen.io/charts';
import { colors as pallete } from '@keen.io/colors';
import { getOffsetRangeColor } from '@keen.io/charts-utils';
export var createLegendLabels = function (data, colors, dataSeriesOffset) {
    var labels = data.map(function (item, idx) { return ({
        name: item,
        color: item !== OTHERS_DATA_KEY
            ? getOffsetRangeColor(idx, colors, dataSeriesOffset)
            : pallete.gray[500],
    }); });
    return labels;
};
